export class StorageKeysModel {
  auth: string;
  profile: string;
  logging: string;
  authExpiration: string;
  settings: string;
  refreshToken: string;
}
